import type { Studio, StudioSummary } from '@/types/studio'

/**
 * Mock studio data
 */
export const studios: Studio[] = [
  {
    id: 'studio-1',
    name: 'AerialFlow Studio San Francisco',
    slug: 'aerialflow-sf',
    description: 'Premier aerial arts studio in the heart of San Francisco',
    logo: undefined,
    coverImage: undefined,
    email: 'info@aerialflow-sf.com',
    phone: '(415) 555-0123',
    address: {
      street: '123 Mission Street',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94103',
      country: 'USA',
    },
    website: 'https://aerialflow-sf.com',
    socialLinks: {
      instagram: 'aerialflow_sf',
      facebook: 'aerialflowsf',
    },
    settings: {
      isPublic: true,
      autoApproveMembers: true,
      defaultClassCapacity: 10,
      allowWaitlist: false,
      currency: 'USD',
      timezone: 'America/Los_Angeles',
      lateFees: {
        enabled: true,
        noShowFeeAmount: 2500, // $25.00
        lateCancellationFeeAmount: 1500, // $15.00
        lateCancellationWindowHours: 24,
      },
      enableReporting: true,
      enablePrivateNotes: true,
      enableCelebrations: true,
    },
    createdAt: '2024-01-15T00:00:00Z',
    updatedAt: '2024-12-01T00:00:00Z',
  },
  {
    id: 'studio-2',
    name: 'Sky High Aerials',
    slug: 'sky-high-aerials',
    description: 'Community-focused aerial studio welcoming all levels',
    email: 'hello@skyhighaerials.com',
    phone: '(415) 555-0456',
    address: {
      street: '456 Valencia Street',
      city: 'San Francisco',
      state: 'CA',
      zipCode: '94110',
      country: 'USA',
    },
    settings: {
      isPublic: false, // Invite-only
      autoApproveMembers: true,
      defaultClassCapacity: 8,
      allowWaitlist: false,
      currency: 'USD',
      timezone: 'America/Los_Angeles',
      lateFees: {
        enabled: true,
        noShowFeeAmount: 2000, // $20.00
        lateCancellationFeeAmount: 1000, // $10.00
        lateCancellationWindowHours: 12,
      },
      enableReporting: true,
      enablePrivateNotes: true,
      enableCelebrations: true,
    },
    createdAt: '2023-06-01T00:00:00Z',
    updatedAt: '2024-11-15T00:00:00Z',
  },
]

/**
 * Get studio by ID
 */
export function getStudioById(id: string): Studio | undefined {
  return studios.find((studio) => studio.id === id)
}

/**
 * Get studio by slug
 */
export function getStudioBySlug(slug: string): Studio | undefined {
  return studios.find((studio) => studio.slug === slug)
}

/**
 * Mock studio summaries with member counts
 */
export const studioSummaries: StudioSummary[] = studios.map((studio) => ({
  ...studio,
  memberCount: studio.id === 'studio-1' ? 124 : 67,
  activeClassCount: studio.id === 'studio-1' ? 32 : 18,
}))
